import { useEffect, useState } from "react";

function CompensationInput({ data, type, label, durationCompensationAppointment, setDurationCompensationAppointment, setFormErrors , formErrors}) {
    const [selectedCompensation, setSelectedCompensation] = useState();
    const [error, setError] = useState("");
    

    useEffect(() => {

        if(type=="blood-stick"){

            if (formErrors && formErrors[data.id]?.additional_stick) {
                setError(formErrors[data.id]?.additional_stick);
            } else {
                setError(""); // Clear error if no issues
            }
        }
        else{
            
            if (formErrors && formErrors[data.id]?.cost) {
                setError(formErrors[data.id]?.cost);
            } else {
                setError(""); // Clear error if no issues
            }
        }
    }, [formErrors]);
    
    const handleCompensationChange = (e) => {
        const value = e.target.value.trim();
        const fieldType = type === "blood-stick" ? "additional_stick" : "cost"; 
        setSelectedCompensation(value);
    
        if (!value) {
            setError("This field is required");
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                [data.id]: {
                    ...prevErrors[data.id],
                    [fieldType]: "This field is required",
                },
            }));
        }
        else{

            setError("");
            setFormErrors((prevErrors) => {
                const { [data.id]: currentErrors, ...rest } = prevErrors;
                if (currentErrors) {
                    const { [fieldType]: _, ...remainingErrors } = currentErrors;
                    return Object.keys(remainingErrors).length > 0
                    ? { ...rest, [data.id]: remainingErrors }
                    : rest; // Remove the entry if no errors remain
                }
                return rest;
            });
        }
    
        // If the type is not "blood-stick"
        if (type !== "blood-stick") {
            // Update the specific appointment's cost only
            const updatedAppointments = durationCompensationAppointment.map((appointment) => {
                if (appointment.id === data.id) {
                    return { ...appointment, cost: value }; // Update cost only for the matching id
                }
                return appointment;
            });
    
            setDurationCompensationAppointment(updatedAppointments);
    
        } else {
            // If the type is "blood-stick", update all appointments with the same sample_id
            const updatedAppointments = durationCompensationAppointment.map((appointment) => {
                if (appointment.sample_id === data.sample_id) {
                    return { ...appointment, additional_stick: value }; // Update additional_stick for all matching sample_id
                }
                return appointment;
            });
    
            setDurationCompensationAppointment(updatedAppointments);
        }
    };
    
    useEffect(() => {
        const initialValue = type === "blood-stick" ? data?.additional_stick || "" : data?.cost || "";
        setSelectedCompensation(initialValue);
    }, [data, type]);

    const handleDecimalNumber = (event) => {
        if (event.key === "-" || event.key === "+" ) {
            event.preventDefault();
        }
        
        // Prevent "0" as the first character
        if (event.key === "0" && event.target.value === "") {
            event.preventDefault();
        }   
    };
    return (
        <>
            <div className="col-md-6">
                <div>           
                <label htmlFor="exampleInputEmail1" className="form-label  appointment-duration-compensation left-38">{label}<span className="text-danger"> *</span></label>
                    <div className="input-group mb-1">
                        <span className="input-group-text">$</span>
                        <input type="number" min={1} className="form-control" onKeyDown={handleDecimalNumber} onChange={handleCompensationChange} value={selectedCompensation ? selectedCompensation : ''} placeholder="Type here.." aria-label="Amount (to the nearest dollar)" />

                    </div>
                    {error && (
                        <div>
                            <p name="error_message" className="text-danger">
                                {error}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );

}
export default CompensationInput